export default __webpack_public_path__ + "static/media/spy.f150ef17.svg";